import { Outlet } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';

// Full-bleed shell for auth pages (split layout lives in Login / Register).
const LightAuthLayout = () => (
  <Box sx={{ minHeight: '100vh', bgcolor: '#FFFFFF' }}>
    <CssBaseline />
    <Outlet />
  </Box>
);

export default LightAuthLayout;
